/**
 * Copyright (c) 2022 FMR LLC.
 * All Rights Reserved.
 * Fidelity Confidential Information.
 */

import { ContentItemModel } from './../models/content-model';
import { FractionalCDOfferingsModel } from './../models/fractional-cd-model';
import { reactive } from 'vue';

export default reactive({
    offeringsModel: new FractionalCDOfferingsModel('', []),
    offeringsLoaded: false,
    offeringsError: false,
    contentItems: [] as ContentItemModel[],
    contentLoaded: false,
    contentError: false,

    loadOfferings(model: FractionalCDOfferingsModel) {
        this.offeringsModel = model;
        this.offeringsLoaded = true;
        this.offeringsError = false;
    },

    resetOfferings() {
        this.offeringsModel = new FractionalCDOfferingsModel('', []);
        this.offeringsLoaded = false;
        this.offeringsError = false;
    },

    errorLoadingOfferings() {
        this.offeringsModel = new FractionalCDOfferingsModel('', []);
        this.offeringsLoaded = false;
        this.offeringsError = true;
    },

    loadContent(model: ContentItemModel[]) {
        this.contentItems = model;
        this.contentLoaded = true;
        this.contentError = false;
    },

    resetContent() {
        this.contentItems = [];
        this.contentLoaded = false;
        this.contentError = false;
    },

    errorLoadingContent() {
        this.contentItems = [] as ContentItemModel[];
        this.contentLoaded = false;
        this.contentError = true;
    },

    resetAll() {
        this.resetOfferings();
        this.resetContent();
    }
});
